
import { BaseI18nManager } from "../../../../i18n";

export type Labels = {

    username: string;

}

export const i18nManager = new BaseI18nManager<Labels>({
    en_UK: require("./en_UK.json"),
});
